import { Grid, TextField, InputAdornment } from "@mui/material";
import { forwardRef, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Controller, useForm } from "react-hook-form";
import { NumericFormat } from "react-number-format";
import { Pins, setUpdateExcelDialog } from "../../../app/slices/pinsSlice";
import { Operation } from "../../../app/slices/operationSlice";
import { HiOutlinePencilSquare, HiOutlineBanknotes } from "react-icons/hi2";
import FormDialog, { SectionCard } from "../../../components/FormDialog";

const UpdateExcelPriceForm = (props) => {
  const dispatch = useDispatch();
  const _Pins = useSelector((state) => state.pins.updateExcelPrice);
  const _SearchBody = useSelector((state) => state.operation.searchBody);

  const { control, reset, watch, register, handleSubmit, setValue } = useForm({
    defaultValues: {},
  });

  const onSubmit = (data) => {
    data.operation_id = _Pins.operation_id
    dispatch(Pins.updateExcelPrice(data)).then((x) => {
      dispatch(setUpdateExcelDialog(null));
      dispatch(Operation.getAll(_SearchBody));
    });
  };

  const handleDialog = () => {
    dispatch(setUpdateExcelDialog(null));
  };

  const NumericFormatCustom = forwardRef(function NumericFormatCustom(
    props,
    ref,
  ) {
    const { onChange, ...other } = props;

    return (
      <NumericFormat
        {...other}
        getInputRef={ref}
        onValueChange={(values) => {
          onChange({
            target: {
              name: props.name,
              value: values.value,
            },
          });
        }}
        thousandSeparator
        valueIsNumericString
      />
    );
  });


  return (
    <FormDialog
      open={_Pins.dialog}
      onClose={handleDialog}
      icon={<HiOutlinePencilSquare />}
      title={'تعديل السعر'}
      subtitle="أدخل سعر الشراء الجديد ثم احفظ التغييرات"
      onSubmit={handleSubmit(onSubmit)}
    >
      <SectionCard icon={<HiOutlineBanknotes />} title="السعر">
        <Grid item xs={12}>
          <Controller
            name="buying_price"
            control={control}
            render={({ field }) => (
              <TextField
                required
                size="small"
                label="سعر الشراء للمفرد"
                fullWidth
                {...field}
                sx={{ marginBottom: 1 }}
                InputProps={{
                  inputComponent: NumericFormatCustom,
                  startAdornment: <InputAdornment position="start">IQD</InputAdornment>,
                }}
              />
            )}
          />
        </Grid>
      </SectionCard>
    </FormDialog>
  );
};

export default UpdateExcelPriceForm;
